import { Outlet, useLocation } from "react-router-dom";
import LoginMarketingHeader from "@components/auth/LoginMarketingHeader";
import LoginMarketingFooter from "@components/auth/LoginMarketingFooter";
import useLanguageSelector from "@hooks/useLanguageSelector";
import FloatingLanguageSelector from "@components/auth/FloatingLanguageSelector";

const AuthLayout = ({ children }) => {
  const location = useLocation();

  const {
    langDropdownOpen,
    setLangDropdownOpen,
    langRef,
    languages,
    changeLanguage,
    currentLanguage,
  } = useLanguageSelector();

  return (
    <div className="min-h-screen bg-white flex flex-col font-[Lato]">
      <LoginMarketingHeader />

      <main className="flex-1 flex items-center justify-center px-4 py-10 sm:py-14">
        <div className="w-full max-w-[420px]">
          {children ?? <Outlet key={location.pathname} />}
        </div>
      </main>

      <LoginMarketingFooter />

      <FloatingLanguageSelector
        langDropdownOpen={langDropdownOpen}
        setLangDropdownOpen={setLangDropdownOpen}
        langRef={langRef}
        languages={languages}
        changeLanguage={changeLanguage}
        currentLanguage={currentLanguage}
      />
    </div>
  );
};

export default AuthLayout;
